import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { isTablet, isMobileOnly } from 'react-device-detect'
import VisibilitySensor from 'react-visibility-sensor'
import Row from 'react-bootstrap/row';
import Col from 'react-bootstrap/col';
import '../css/NarrativeCards.scss'

const NarrativeCards = ({ narratives, industryHoverHandler }) => {
  const narrKeyArray = Object.keys(narratives)
  const narrWidth = calculateNarrativeWidth(isTablet ? 2 : isMobileOnly ? 1 : narrKeyArray.length)

  return (
    <div className={`narrative_container`}>
      <Row>
        {narrKeyArray.map((narrativeKey, index) =>
          <NarrativeCard narrativeKey={narrativeKey} industryHoverHandler={industryHoverHandler} narrative={narratives[narrativeKey]} narrWidth={narrWidth} index={index} key={`Narrative-${narrativeKey}`} />
        )}
      </Row>
    </div>
  )
}

const NarrativeCard = ({ narrative, narrWidth, index, industryHoverHandler, narrativeKey }) => {
  const [narrativeVisible, setNarrativeVisible] = useState(false)

  const narrativeVisiblityChange = isVisible => {
    if (isVisible) {
      setNarrativeVisible(true)
    }
  }
  return (
    <Col xs={12} md={6} lg={3}>
      <VisibilitySensor onChange={narrativeVisiblityChange} partialVisibility>
        <div
          onMouseEnter={() => industryHoverHandler(narrativeKey, true)}
          onMouseLeave={() => industryHoverHandler(narrativeKey, false)}
          className={`narrative_card-container fade-up ${narrativeVisible ? 'isVisible' : ''}`} style={{ width: `100%`, height: 'auto', transitionDelay: `${index / 10}s`, backgroundImage: `url(./img/narratives/moduleCrops/${narrative.img_crop})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center' }}>
          <div className='narrative_card'>
            <div className='narrative_card-content'>
              <div className='narrative_cta'>
                <h4 className='narrative-meta'>{narrative.title}</h4>
                <p className='narrative-card-text narrative_text'>
                  {narrative.desc}
                </p>
              </div>
              <Link to={`narrative/${narrative.key}`}
                  className='cta_button'>Learn more</Link>
            </div>
          </div>
        </div>
      </VisibilitySensor>
    </Col>
  )
}

const calculateNarrativeWidth = colCount => {
  return (100 - (2.4 * (colCount - 1))) / colCount
}
export default NarrativeCards
